/*
 * @Author: bbqin
 * @Date: 2023-02-14 10:19:31
 * @LastEditTime: 2023-11-03 16:47:13
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\store.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { BaseStore, hookFactory } from '@platform/template';
import { getGlobalStorage, setGlobalStorage } from "@platform/api";
import { uniqueId, Preset, isArray, uuidv4, isBoolean, isUndefined, getCacheMeta, setCacheMeta, getBillInfo, isString, isObject, isFunction, isPromise, cloneObject } from "./libs/utils";
import useCardStore from './components/card/store';
import preLoad from './components/card/preLoad';

// 组装数据
const containerPath = 'LowCodeComponents.SmartCardContainer';
const panePath = 'LowCodeComponents.SmartCardContainer.SmartCardContainerItem';
const cardWalletPath = 'LowCodeComponents.SmartCardWallet';

// 用于本地测试
const isLocal = NODE_ENV === 'development';

// 审批历史，智能审核
const intelligentAuditingPath = isLocal ? 'base/index' : Preset.auditing.path;
const approvalHistoryPath = isLocal ? 'api/index' : Preset.approval.path;
const pretreatmentCardPath = [intelligentAuditingPath, approvalHistoryPath];

const empty = function () { };

const getVirtuallyWallet = (id, parentId) => {
    return {
        $id: id,
        name: "SmartCardWallet",
        label: "虚拟卡片组",
        // type: 1,
        path: "LowCodeComponents.SmartCardWallet",
        // canAppend: true,
        props: {
            moduleId: "virtuallyWallet" + id,
            visible: true,
            expanded: true,
            // com_id: "4e7949ae",
        },
        // slots: [],
        // groupId: "business_comps",
        // column: 1,
        // customConfigPanel: null,
        // icon: "ddm-from",
        parentId: parentId,
        _isVirtually: true,
    };
};

// 页签下wallet没有了 暂时不隐藏页签
const tabEffect = false;

// scene default name
const SceneDefaultName = '__default';

class Store extends BaseStore {
    constructor(props = {}) {
        super(props);
        this.name = "smartCardStore";
        this.setStore("id", props.id, false);
    }

    // 数据源
    store = {
        id: '',
        meta: [],
        // 缓存相关
        ts: '',
        activeKey: '',

        // 多语
        langJson: {},
        // 模板多语
        multiLangItems: {},

        // 容器模板
        container: null,
        // 容器属性
        containerProps: {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        },

        // 页签顺序
        tabs: [],
        // 页签属性 {moduleId: props}
        tabsProps: {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        },

        // panelId目前为父级的$id
        // 页签下卡片 {<panelId>: [<virtuallyWallet=><card>>, <cardWallet>, ...]}  // 如果只有卡片则套一个虚拟躯壳
        walletLists: {},
        // 卡片夹属性 {moduleId: props}
        walletProps: {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        },

        // walletId目前为父级的$id
        // 卡片包 {<walletId>: [<card>, <card>, ...]}
        cardLists: {},
        // 卡片夹属性 {moduleId: props}
        cardProps: {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        },

        // cardId为card的moduleId
        // 卡片实例 （store）{<cardId>: [<cardStore>, <cardStore>, ...]}
        cardStores: {},
        //  $id和moduleId的对应关系 
        idRelation: {
            container: {
                // {$id: moduleId}
                id: {},
                // {moduleId: $id}
                moduleId: {},
                // {$id: parent}
                parent: {},
            },
            tabs: {
                id: {},
                moduleId: {},
                parent: {},
            },
            wallets: {
                id: {},
                moduleId: {},
                parent: {},
            },
            cards: {
                id: {},
                moduleId: {},
                parent: {},
            },
        },
        // 事件缓存栈
        listenerStore: {},
        // 按场景缓存
        scene: SceneDefaultName,
        // 用于缓存的页面信息
        billInfo: {
            pagecode: '',
            appcode: '',
        },
        pretreatmentCardProps: {},
        // 预加载是否完成, 默认完成
        pretreatmentState: {},
        // 期望激活的页签
        expectActiveTab: [],
        // 记录一下cacheMeta 避免设置localStorage失败导致场景出问题
        cacheMeta: {},
    };

    /**
     * 复写
     * @param {array} paths 
     * @returns {object}
     */
    getStore(paths) {
        return super.get(paths);
    }

    /**
     * 复写
     * @param {array} paths 
     * @param {object} value 
     * @param {boolean} shouldForceUpdate 
     * @param {function} callback 
     * @returns {object}
     */
    setStore(paths, value, shouldForceUpdate = true, callback) {
        let res = super.set(paths, value);
        shouldForceUpdate ? this.forceUpdate(callback) : callback && callback();
        return res;
    }

    // 是否是smartCard的数据
    isSmartContainer(path) {
        return path === containerPath;
    }

    /**
     * 获取当前meta
     * @param {string} id 
     * @param {object} meta 
     * @returns {object}
     */
    _initMeta(id, meta = []) {

        let container = null,
            tabs = [],
            walletLists = {},
            cardLists = {},
            cardStores = this.getStore('cardStores') || {};

        if (!id) {
            console.log('从meta里取数据缺少必要参数id');
            return {
                container,
                tabs,
                walletLists,
                cardLists,
                cardStores,
            };
        }

        // 是否包含container
        const hasContainer = meta.find(element => {
            const { path, props = {} } = element || {};
            const { moduleId } = props || {};
            return moduleId === id && path === containerPath;
        });

        if (!hasContainer) {
            return {
                container,
                tabs,
                walletLists,
                cardLists,
                cardStores,
            };
        }

        meta = this._initPretreatmentCard(id, meta);

        const idRelation = this.getStore('idRelation');
        const {
            container: containerIdRelation,
            tabs: tabsIdRelation,
            wallets: walletsIdRelation,
            cards: cardsIdRelation,
        } = idRelation;

        // 可能会有问题  暂时用一下
        meta.forEach(element => {
            const { $id, path, props = {}, parentId: currentParentId } = element;
            const { moduleId, visible } = props || {};

            // 容器区域
            if (moduleId === id && path === containerPath) {
                container = element;
                // 整理id关系  便于后续查找数据
                containerIdRelation.id[$id] = moduleId;
                containerIdRelation.moduleId[moduleId] = $id;
                containerIdRelation.parent[$id] = currentParentId;
            }

            // 页签项
            const parentId = container?.$id;
            if (parentId && parentId === currentParentId && path === panePath) {
                tabs.push(element);
                walletLists[$id] = walletLists[$id] || [];
                // 整理id关系  便于后续查找数据
                tabsIdRelation.id[$id] = moduleId;
                tabsIdRelation.moduleId[moduleId] = $id;
                tabsIdRelation.parent[$id] = currentParentId;
            }

            // 页签下卡片夹
            if (walletLists[currentParentId]) {
                // 如果卡片夹
                if (path === cardWalletPath) {
                    cardLists[$id] = cardLists[$id] || [];
                    walletLists[currentParentId].push(element);
                    // 整理id关系  便于后续查找数据
                    walletsIdRelation.id[$id] = moduleId;
                    walletsIdRelation.moduleId[moduleId] = $id;
                    walletsIdRelation.parent[$id] = currentParentId;
                } else {
                    // 仅仅是卡片 先套一层卡片
                    const walletId = uuidv4();
                    let virtuallyWallet = getVirtuallyWallet(walletId, currentParentId);
                    cardLists[walletId] = cardLists[walletId] || [];

                    // TODO 要不要改变card的父ID
                    walletLists[currentParentId].push(virtuallyWallet);
                    // 整理id关系  便于后续查找数据
                    const virtuallyWallet$id = virtuallyWallet.$id;
                    const virtuallyWalletModuleId = virtuallyWallet.props.moduleId;
                    walletsIdRelation.id[virtuallyWallet$id] = virtuallyWalletModuleId;
                    walletsIdRelation.moduleId[virtuallyWalletModuleId] = virtuallyWallet$id;
                    walletsIdRelation.parent[virtuallyWallet$id] = currentParentId;

                    // 卡片夹数据
                    cardLists[walletId].push(element);
                    idRelation.cards[$id] = moduleId;

                    // 整理id关系  便于后续查找数据
                    cardsIdRelation.id[$id] = moduleId;
                    cardsIdRelation.moduleId[moduleId] = $id;
                    cardsIdRelation.parent[$id] = walletId;

                    // 初始化cardStore
                    if (!cardStores[moduleId]) {
                        cardStores[moduleId] = useCardStore({
                            id: moduleId,
                            props: props,
                        });
                    } else {
                        // TODO 是否要合并 props属性
                        cardStores[moduleId]?.updateCardProps(props, true);
                    }

                }
            }
            // 卡片夹下数据
            if (cardLists[currentParentId]) {
                cardLists[currentParentId].push(element);
                // 整理id关系  便于后续查找数据
                cardsIdRelation.id[$id] = moduleId;
                cardsIdRelation.moduleId[moduleId] = $id;
                cardsIdRelation.parent[$id] = currentParentId;

                // 初始化cardStore
                if (!cardStores[moduleId]) {
                    cardStores[moduleId] = useCardStore({
                        id: moduleId,
                        props: props,
                    });
                } else {
                    // TODO 是否要合并 props属性
                    cardStores[moduleId]?.updateCardProps(props, true);
                }
            }
        });

        // 初始化原始数据
        this.setStore(["container"], container, false);
        this.setStore(["tabs"], tabs, false);
        this.setStore(["walletLists"], walletLists, false);
        this.setStore(["cardLists"], cardLists, false);
        this.setStore(["cardStores"], cardStores, false);
        this.setStore(["idRelation"], idRelation, false);
    }

    /**
     * 创建layout数据
     */
    createLayoutItem(type, parentId, props) {
        let item = {};

        const uuid = uuidv4();

        switch (type) {
            case 'tab':
                item = {
                    $id: 'tab_' + uuid,
                    isCustom: true,
                    name: "SmartCardContainerItem",
                    label: "页签",
                    type: 1,
                    path: panePath,
                    canAppend: true,
                    props: {
                        moduleId: "SmartCardContainerItem_" + uuid,
                        tab: "生成默认页签",
                        key: "SmartCardContainerItem_" + uuid,
                        visible: true,
                        ...props,
                        isCustom: true,
                    },
                    slots: [
                    ],
                    groupId: "layout_comps",
                    column: 1,
                    customConfigPanel: null,
                    icon: "",
                    parentId: parentId,
                };

                break;
            case 'wallet':
                item = {
                    $id: 'wallet_' + uuid,
                    name: "SmartCardWallet",
                    isCustom: true,
                    label: "卡片组",
                    type: 1,
                    path: "LowCodeComponents.SmartCardWallet",
                    canAppend: true,
                    props: {
                        moduleId: "wallet_" + uuid,
                        visible: true,
                        expanded: true,
                        title: "生成默认卡片组",
                        com_id: 'wallet_' + uuid,
                        ...props,
                        isCustom: true,
                    },
                    slots: [

                    ],
                    groupId: "container_comps",
                    column: 1,
                    customConfigPanel: null,
                    icon: "ddm-from",
                    parentId: parentId,
                };
                break;

            case 'card':
                item = {
                    $id: "card_" + uuid,
                    isCustom: true,
                    name: "LowCodeComponents.CardLoadTest",
                    label: "卡片",
                    type: 1,
                    path: props._cardPath,
                    canAppend: false,
                    props: {
                        moduleId: "card_" + uuid,
                        display: false,
                        com_id: "card_" + uuid,
                        visible: true,
                        ...props,
                        isCustom: true,
                    },
                    slots: [],
                    groupId: "business_comps",
                    column: 1,
                    customConfigPanel: null,
                    icon: "ddm-zhipaixiangqing",
                    parentId: parentId,
                };
                break;
            default:
                break;
        }

        return item;
    }

    /**
     * 初始化特殊的卡片
     */
    _initPretreatmentCard(id, meta = []) {

        let container$id = null;
        let containerIndex = null;

        // 是否包含container
        const hasContainer = meta.find((element, index) => {
            const { $id, path, props = {}, isCustom } = element || {};
            const { moduleId } = props || {};
            const matched = moduleId === id && path === containerPath;
            if (matched) {
                container$id = $id;
                containerIndex = index;
            }
            return matched;
        });
        // 是否已经有特殊页签
        const hasCustom = meta.find(element => {
            const { $id, path, props = {}, isCustom } = element || {};
            const { moduleId } = props || {};
            return isCustom;
        });

        if (hasContainer && !hasCustom) {
            const tab1 = this.createLayoutItem('tab', container$id, {
                tab: '智能审核',
                moduleId: Preset.auditing.tabId,
                // 默认不显示
                visible: false,
            });
            const wallet1 = this.createLayoutItem('wallet', tab1.$id, {
                title: '智能审核卡组',
                moduleId: Preset.auditing.walletId,
            });
            const card1 = this.createLayoutItem('card', wallet1.$id, {
                title: '智能审核卡片',
                moduleId: Preset.auditing.cardId,
                _cardPath: intelligentAuditingPath,
            });
            const tab2 = this.createLayoutItem('tab', container$id, {
                tab: '流程信息',
                moduleId: Preset.approval.tabId,
                // 默认不显示
                visible: false,
            });
            const wallet2 = this.createLayoutItem('wallet', tab2.$id, {
                title: '流程信息卡组',
                moduleId: Preset.approval.walletId,
            });
            const card2 = this.createLayoutItem('card', wallet2.$id, {
                title: '流程信息卡片',
                moduleId: Preset.approval.cardId,
                _cardPath: approvalHistoryPath,
            });

            // meta.splice(containerIndex + 1, 0, tab, wallet, card);
            meta.splice(meta.length, 0, tab1, wallet1, card1, tab2, wallet2, card2);
        }

        return meta;
    }

    /**
     * 处理显示隐藏性等属性
     */
    _handleProps() {
        const container = this.getStore('container');

        if (!container) {
            return;
        }

        // 多语
        const metaLang = this.getMetaLang();

        // 数据
        const tabs = this.getStore('tabs');
        const walletLists = this.getStore('walletLists');
        const cardLists = this.getStore('cardLists');
        const cardStores = this.getStore('cardStores');
        // 属性
        const containerProps = this.getStore('containerProps');
        const tabsProps = this.getStore('tabsProps');
        const walletProps = this.getStore('walletProps');
        const cardProps = this.getStore('cardProps');
        // $id和moduleId关系
        const idRelation = this.getStore('idRelation');
        const {
            container: containerIdRelation,
            tabs: tabsIdRelation,
            wallets: walletsIdRelation,
            cards: cardsIdRelation,
        } = idRelation;

        // 容器props
        containerProps.origin = container.props;
        const containerLangText = metaLang[container?.props?.moduleId]?.tranitemvalue;
        containerProps.current = { ...containerProps.origin, ...containerProps.current, _langText: containerLangText };

        // 智能审核 预处理页签
        const pretreatmentTarget = {
            card: {},
            wallet: {},
            tab: {},
        };

        // 卡片
        const walletNextVisible = {};
        for (const key in cardLists) {
            const cards = cardLists[key] || [];

            // 卡片夹显隐性默认是false 如果有一个卡片显示  就变为显示
            const walletModuleId = walletsIdRelation.id[key];
            walletProps.current[walletModuleId] = walletProps.current[walletModuleId] || {};
            walletNextVisible[walletModuleId] = false;
            // 遍历卡片
            cards.forEach(item => {
                const { $id, props = {}, path } = item;
                const { moduleId } = props;
                const cardStore = cardStores[moduleId];
                const cardLangText = metaLang[moduleId]?.tranitemvalue;

                // 同步下props
                const currentCardProps = cardStore ? cardStore.getCardProps() : {};
                cardProps.origin[moduleId] = props;
                // moduleId不能被修改，设置的cardProps优先级高于默认属性, visible 默认true
                cardProps.current[moduleId] = { visible: true, ...props, ...currentCardProps, ...(cardProps.current[moduleId] || {}), moduleId, _langText: cardLangText };

                cardStore && cardStore.setStore(['props'], cardProps.current[moduleId]);

                if (cardProps.current[moduleId].visible !== false) {
                    // 卡片夹是否显示
                    walletNextVisible[walletModuleId] = true;
                }

                // 某些卡片隐藏后预加载
                if (pretreatmentCardPath.includes(path)) {
                    pretreatmentTarget.card[moduleId] = { parentModuleId: walletModuleId, ...item };
                    pretreatmentTarget.wallet[walletModuleId] = true;
                }
            });
        }
        // 卡片组
        const tabNextVisible = {};
        for (const key in walletLists) {
            const wallets = walletLists[key];
            // 页签默认是false 如果有一个卡片夹显示  就变为显示
            const tabModuleId = tabsIdRelation.id[key];
            tabsProps.current[tabModuleId] = tabsProps.current[tabModuleId] || {};

            // tab没有wallet时 页签也不隐藏
            tabNextVisible[tabModuleId] = !tabEffect;

            wallets.forEach(item => {
                const { $id, props = {} } = item;
                const { moduleId, visible, originVisible, userVisible } = props;
                const walletLangText = metaLang[moduleId]?.tranitemvalue;

                // 卡片夹props整理
                walletProps.origin[moduleId] = props;
                // 用于解决领域设置了visible属性 需要缓存的问题, 有originVisible说明是读取的缓存数据
                let finalOriginVisible = isUndefined(originVisible) ? visible : originVisible;

                walletProps.current[moduleId] = { ...props, ...(walletProps.current[moduleId] || {}), originVisible: finalOriginVisible, userVisible: userVisible, _langText: walletLangText };
                // 根据子集来判断父级是否显示
                const walletCurrentVisible = walletProps.current[moduleId].visible;
                walletProps.current[moduleId].visible = walletCurrentVisible === false ? walletCurrentVisible : walletNextVisible[moduleId];

                if (walletProps.current[moduleId].visible !== false) {
                    // 页签是否显示
                    tabNextVisible[tabModuleId] = true;
                }

                item.props = props;

                // 某些卡片隐藏后预加载
                if (pretreatmentTarget.wallet[moduleId]) {
                    pretreatmentTarget.wallet[moduleId] = { parentModuleId: tabModuleId, ...item };
                    pretreatmentTarget.tab[tabModuleId] = true;
                }
            });
        }

        // 页签
        // 如果有一个页签就显示
        let containerNextVisible = false;
        tabs.forEach(tab => {
            const { $id, props = {} } = tab;
            const { moduleId } = props;
            const tabLangText = metaLang[moduleId]?.tranitemvalue;

            // props整理
            tabsProps.origin[moduleId] = props;
            tabsProps.current[moduleId] = { ...props, ...(tabsProps.current[moduleId] || {}), _langText: tabLangText };

            // 父级如果不显示 则不显示 否则 根据子集进行计算
            const tabCurrentVisible = tabsProps.current[moduleId].visible;
            tabsProps.current[moduleId].visible = tabCurrentVisible === false ? tabCurrentVisible : tabNextVisible[moduleId];

            // 某些卡片隐藏后预加载
            if (pretreatmentTarget.tab[moduleId]) {
                pretreatmentTarget.tab[moduleId] = tab;

                // 如果是切换场景，不要先隐藏再加载，二是重新加载判断显隐性
                tabsProps.current[moduleId].visible = tabsProps.current[moduleId].visible || false;
            }

            if (tabsProps.current[moduleId].visible !== false) {
                // 如果有一个页签就显示
                containerNextVisible = true;
            }
        });

        // 如果所有页签都不显示 则父级也不显示，如果父级本身就不显示，则不受子元素影响
        const containerCurrentVisible = containerProps.current.visible;
        containerProps.current.visible = containerCurrentVisible === false ? containerCurrentVisible : containerNextVisible;

        // 存储属性
        this.setStore(["containerProps"], containerProps, false);
        this.setStore(["tabsProps"], tabsProps, false);
        this.setStore(["walletProps"], walletProps, false);
        this.setStore(["cardProps"], cardProps, false);
        this.setStore(["pretreatmentTarget"], pretreatmentTarget, false);
    }

    // 加载预处理的组件
    reloadPretreatmentCard(cardIds, callback, shouldForceUpdate = true) {
        const that = this;
        this._loadPretreatmentCard(cardIds, success => {
            callback && callback(success);
            success && shouldForceUpdate && that.forceUpdate();
        });
    }

    /**
     * 是否包含影响显隐性的属性
     */
    _getEffectVisible(moduleId, cardProps) {
        let effectVisible = false;
        // 启动了门，说明是门内，则不需要控制智能审核等的显隐性
        const isPortalStartup = this.getStore('isPortalStartup');

        if (isPortalStartup) {
            return false;
        }

        if ((moduleId === Preset.approval.cardId)) {
            effectVisible = Preset.approval.effectVisible.every(key => cardProps[key]);
        }
        if ((moduleId === Preset.auditing.cardId)) {
            effectVisible = Preset.auditing.effectVisible.every(key => cardProps[key] !== undefined);
        }
        return effectVisible;
    }

    // 加载预处理的组件
    _loadPretreatmentCard(cardIds, callback) {
        const { card = {}, wallet = {}, tab = {} } = this.getStore('pretreatmentTarget') || {};
        const that = this;
        const cards = isArray(cardIds) && cardIds.length ? cardIds.map(cardId => card[cardId]) : Object.values(card);
        if (!cards.length || !Object.keys(card).length) {
            return callback && callback(false);
        }

        const pretreatmentCardProps = that.getStore('pretreatmentCardProps') || {};

        const pretreatmentState = this.getStore('pretreatmentState');

        try {
            cards.forEach(item => {
                const { props = {}, path, parentModuleId } = item;
                const { moduleId, visible, componentNameSpace } = props;
                const currentWallet = wallet[parentModuleId] || {};
                const tabId = (tab[currentWallet.parentModuleId] || {})?.props?.moduleId;
                const cardProps = { ...pretreatmentCardProps, ...(that.getCardProps(moduleId) || {}), smartCardStore: that };

                // 里面有逻辑，如果已经加在的就不会再次加在
                preLoad(path, componentNameSpace, (component, others) => {
                    // 某些情况下不执行getVisible
                    let effectVisible = that._getEffectVisible(moduleId, cardProps);

                    that.setStore('isLoadPretreatmentComponent', true, false);

                    if ((!effectVisible || !component) && !isLocal) {
                        callback && callback(false);
                        return;
                    }

                    const { getVisible } = component;
                    const result = isFunction(getVisible) ? getVisible(cardProps) : false;
                    if (result === 'neglect') {
                        console.warn('多次调用侧边设值时，领域可以控制此次设置处理无效，沿用前次设置。');
                    } else if (isPromise(result)) {
                        result.then(visible => {
                            console.log(tabId, '加载成功了');
                            // 解决  复制  新增等情况下 触发了多次表单字段变化，异步导致的最终状态不正确的问题
                            const currentCardProps = that.getCardProps(moduleId);
                            let currentEffectVisible = that._getEffectVisible(moduleId, currentCardProps);
                            if (!currentEffectVisible && !isLocal) {
                                callback && callback(false);
                                return;
                            }

                            const prevVisible = that.getTabProps(tabId, 'visible');
                            that.setTabProps(tabId, 'visible', visible, false, empty, true);
                            // 第一次加载完成 第一个页签  页签显示
                            // if (pretreatmentState[tabId] === undefined && expectActiveTab[0] === moduleId && visible) {
                            //     that.setContainerActiveTab(tabId, true);
                            // }
                            if (pretreatmentState[tabId] === undefined && visible) {
                                that.setStore(['pretreatmentState', tabId], true, false);
                                // that.setContainerActiveTab(tabId, true);
                            }
                            if (prevVisible !== visible) {
                                that.forceUpdate();
                            }
                            callback && callback(true);
                        }).catch(visible => {
                            console.log('失败了');
                            const prevVisible = that.getTabProps(tabId, 'visible');
                            that.setTabProps(tabId, 'visible', visible, false, empty, true);
                            if (prevVisible !== visible) {
                                that.forceUpdate();
                            }
                            callback && callback(false);
                        });
                    } else {
                        that.setTabProps(tabId, 'visible', result, false, empty, true);
                        callback && callback(false);
                    }
                }, () => {
                    callback && callback(false);
                    console.log('加载失败了');
                });
            });
        } catch (error) {
            console.error('有错误');
            console.error(error);
        }
    }

    /**
     * 设置模板的多语
     * @param {object} multiLangItems 
     */
    setMetaLang(multiLangItems = {}) {
        this.setStore('multiLangItems', multiLangItems);
    }

    /**
     * 获取模板多语
     * @returns {object}
     */
    getMetaLang() {
        return this.getStore('multiLangItems') || {};
    }

    /**
     * 设置所有meta
     * @param {object} meta 
     * @param {string} id 
     * @param {boolean} shouldForceUpdate 
     */
    setMeta(meta = [], id, shouldForceUpdate = true) {
        id && this.setStore("id", id, false);

        // 初始化billInfo 一般用于缓存
        let nextBillInfo = this.getStore('billInfo');
        const { appcode, pagecode } = nextBillInfo;
        if (!appcode || !pagecode) {
            nextBillInfo = getBillInfo();
            this.setBillInfo(nextBillInfo, false);
        }

        const isNextMeta = this.isNextMeta(id);

        // TODO 原始meta中的内容是否要和当前缓存的meta进行对比
        meta = this.getCacheMeta(id, meta);

        // 序列化 反序列化 serialize和deserialize  这个有待考虑
        this._initMeta(id, meta);

        // 处理属性
        this._handleProps();

        // 领域在编辑前或者编辑后时会触发setMeta 此时不需要发请求，通过是否已经加载过来判断
        const isLoadPretreatmentComponent = this.getStore('isLoadPretreatmentComponent');
        // 处理特殊情况，预加载，只加载一次，uniqueId不进行处理
        uniqueId !== id && (!isLoadPretreatmentComponent || isNextMeta) && this._loadPretreatmentCard();

        // 缓存一次meta
        this.setCacheMeta(id);

        this.setStore(["meta"], meta, shouldForceUpdate);
    }

    /**
     * 获取所有meta
     * @returns {object}
     */
    getMeta = () => {
        let meta = this.getStore("meta");
        return meta;
    };

    /**
     * @description: 获取id所在视图的meta
     * @returns {object}
     */
    getViewMeta(id) {
        let container = this.getStore("container");
        let tabs = [];
        let walletLists = {};
        let cardStores = {};
        let cardLists = {};
        // 如果没有数据  尝试重新初始化下
        if (!container) {
            const meta = this.getStore("meta");
            // 初始化模板数据
            this._initMeta(id, meta);
            this._handleProps();
        }

        container = this.getStore("container");
        tabs = this.getStore("tabs");
        walletLists = this.getStore("walletLists");
        cardLists = this.getStore("cardLists");
        cardStores = this.getStore("cardStores");

        return {
            container,
            tabs,
            walletLists,
            cardLists,
            cardStores,
        };
    }

    /**
     * 获取智能区容器的属性
     * @param {string|array} key 
     */
    getContainerProps(key) {
        if (isUndefined(key)) {
            // 没传 返回所有属性
            return this.getStore(['containerProps', 'current']);
        }
        key = isArray(key) ? key : [key];
        let value = this.getStore(['containerProps', 'current', ...key]);
        return value;
    }

    /**
     * 设置智能区容器的属性
     * @param {string|array} key 
     */
    setContainerProps(key, value, shouldForceUpdate, callback) {
        if (key === 'moduleId') {
            console.warn('moduleId为唯一属性，请勿修改');
        }
        key = isArray(key) ? key : [key];
        this.setStore(['containerProps', 'current', ...key], value, false);

        shouldForceUpdate ? this.forceUpdate(callback) : callback && callback();
    }

    /**
     * 获取激活的页签
     * expectActiveTab 避免异步加载的页签没有正常激活
     */
    getContainerActiveTab(tabs = []) {
        let tabId = this.getStore(['containerProps', 'current', 'activeKey']) || this.getStore(['containerProps', 'current', '_activeKey']);
        let visible = true;
        if (tabId) {
            visible = this.getStore(['tabsProps', 'current', tabId, 'visible']);
            // 判断是不存在还是自定义渲染的页签
            if (visible === undefined) {
                visible = tabs.find(item => item && item.__isCustom && visible?.props?.moduleId == tabId);
            }
        }

        // 自定义页签没有visible  所以不能用 !visible
        if (!tabId || !visible) {
            // 取第一个页签激活
            const firstTab = (this.getTabs(props => props.visible) || [])[0];
            tabId = firstTab?.props?.moduleId;
            // 由于有两个页签时异步的  只做渲染效果  不做更新了 不然没有办法做最终页签显示的判断
            // this.setContainerProps('activeKey', tabId, false);
        }

        // 如果已经完成预加载
        const expectActiveTab = this.getStore('expectActiveTab');
        const pretreatmentState = this.getStore('pretreatmentState');
        const visibleTabs = this.getTabs(props => props.visible !== false &&
            props.moduleId !== Preset.auditing.tabId &&
            props.moduleId !== Preset.approval.tabId);

        // 审批中心和共享中情况  以及只有智能审核和审批历史的情况
        if ((expectActiveTab.includes(Preset.approval.tabId) || !visibleTabs.length)) {
            // 审批历史必定会请求  在它完成之前先不激活页签 不是智能审核激活了
            if (pretreatmentState[Preset.approval.tabId] === undefined && tabId !== Preset.auditing.tabId) {
                tabId = '上下左右baba';
            }
            if (pretreatmentState[Preset.approval.tabId]) {
                tabId = tabId !== Preset.auditing.tabId ? Preset.approval.tabId : Preset.auditing.tabId;
                this.setContainerProps('activeKey', tabId, false);
                this.setStore(['pretreatmentState', Preset.approval.tabId], false, false);
            }
        }

        // 审批中心和共享中情况  以及只有智能审核和审批历史的情况
        if ((expectActiveTab.includes(Preset.auditing.tabId) || !visibleTabs.length)) {
            // if (pretreatmentState[Preset.auditing.tabId] === undefined) {
            // }
            if (pretreatmentState[Preset.auditing.tabId]) {
                tabId = Preset.auditing.tabId;
                this.setContainerProps('activeKey', tabId, false);
                this.setStore(['pretreatmentState', Preset.auditing.tabId], false, false);
            }
        }

        return tabId;
    }

    /**
     * 设置激活的页签
     */
    setContainerActiveTab(value, shouldForceUpdate, callback) {
        this.setContainerProps(['activeKey'], value, shouldForceUpdate, callback);
    }

    /**
     * 获取页签
     * @param {function} filter 
     * @returns {object}
     */
    getTabs(filter) {
        const tabs = this.getStore(['tabs']);
        const tabsProps = this.getStore(['tabsProps']);
        let result = tabs;
        if (filter) {
            result = tabs.filter(item => {
                const { props = {} } = item || {};
                const { moduleId } = props;
                const currentProps = tabsProps.current[moduleId] || {};

                if (filter && filter(currentProps)) {
                    return true;
                }
                return false;
            });
        }
        return result;
    }

    /**
     * 获取页签的属性
     * @param {string} tabId 
     * @param {string} key 
     * @returns {object}
     */
    getTabProps(tabId, key) {
        if (isUndefined(key)) {
            return this.getStore(['tabsProps', 'current', tabId]) || {};
        }
        key = isArray(key) ? key : [key];
        let value = this.getStore(['tabsProps', 'current', tabId, ...key]);
        return value;
    }

    /**
     * 设置页签的属性
     * @param {string} tabId 
     * @param {string} key 
     * @param {any} value 
     * @param {boolean} shouldForceUpdate 
     */
    setTabProps(tabId, key, value, shouldForceUpdate, callback, shouldUpdateContainer = true) {
        if (key === 'moduleId') {
            console.warn('moduleId为唯一属性，请勿修改');
        }
        key = isArray(key) ? key : [key];
        this.setStore(['tabsProps', 'current', tabId, ...key], value, false);

        // 显隐性有关联关系  需要调整父级显隐性
        if (key[0] === 'visible') {
            const tabs = this.getStore('tabs');
            const tabsProps = this.getStore('tabsProps');

            let containerVisible = false;
            tabs.some(tab => {
                const { props = {} } = tab;
                const { moduleId } = props;
                if (tabsProps.current[moduleId]?.visible !== false) {
                    containerVisible = true;
                    return true;
                }
            });
            // 内置的审批详情和智能审核页签设置显隐性时会影响整个区域的显隐性  比较复杂
            // if (![Preset.approval.tabId, Preset.auditing.tabId].includes(tabId)) { // 会有问题
            // if (shouldUpdateContainer) {  // 也有问题
            const containerProps = this.getStore('containerProps');
            const originVisible = containerProps?.origin?.visible;
            const currentVisible = containerProps?.current?.visible;
            // 如果整个区域初始显示或者业务对整个区域设置了显示，则可以触发父级显隐性更新
            if (originVisible || currentVisible) {
                this.setContainerProps('visible', containerVisible, false);
            }
        }

        shouldForceUpdate ? this.forceUpdate(callback) : callback && callback();

    }

    /**
     * 获取某个页签下的的walletList
     * @param {string} tabId 
     */
    getWalletListByTabId(tabId) {
        let res = [];
        const walletLists = this.getStore(['walletLists']);
        const tabs = this.getStore(['tabs']);
        let tabRelationId = '';
        tabs.some(tab => {
            const { $id, props = {} } = tab || {};
            const { moduleId } = props;
            if (moduleId === tabId) {
                tabRelationId = $id;
                return true;
            }
        });
        if (tabRelationId) {
            res = walletLists[tabRelationId] || [];
        } else {
            console.log(`未找到tabId为${tabId}的页签下的walletList数据`);
        }

        return res;
    }

    /**
     * 获取卡片夹  TODO
     * @param {string} tabId 
     * @param {function} filter 
     * @param {boolean} filterVirtually 
     * @returns {object}
     */
    getCardWallets(tabId, filter, filterVirtually = true) {
        let res = [];
        if (!tabId) {
            // 保证顺序正确
            const tabs = this.getStore(['tabs']);
            const walletLists = this.getStore(['walletLists']);
            const walletProps = this.getStore(['walletProps']);
            // 扫描一遍所有的数据
            tabs.forEach(tab => {
                const { $id } = tab;
                const walletList = walletLists[$id] || [];
                const temp = walletList.filter(wallet => {
                    const { props = {}, _isVirtually } = wallet || {};
                    // 去除虚拟卡片
                    if (_isVirtually && filterVirtually) {
                        return false;
                    }
                    const { moduleId } = props;
                    const currentProps = walletProps.current[moduleId] || {};
                    return filter ? filter(currentProps, wallet) : true;
                });
                res = [...res, ...temp];
            });
        } else {
            const walletList = this.getWalletListByTabId(tabId);
            const walletProps = this.getStore(['walletProps']);

            const temp = walletList.filter(wallet => {
                const { props = {}, _isVirtually } = wallet || {};
                // 去除虚拟卡片
                if (_isVirtually && filterVirtually) {
                    return false;
                }
                const { moduleId } = props;
                const currentProps = walletProps.current[moduleId] || {};
                return filter ? filter(currentProps, wallet) : true;
            });
            res = [...res, ...temp];
        }
        return res;
    }

    /**
     * TODO
     * 获取卡片夹属性
     * @param {string} walletId 
     * @param {string} key 
     */
    getCardWalletProps(walletId, key) {
        if (isUndefined(key)) {
            return this.getStore(['walletProps', 'current', walletId]) || {};
        }
        key = isArray(key) ? key : [key];
        let value = this.getStore(['walletProps', 'current', walletId, ...key]);
        return value;
    }

    /**
     * TODO
     * 卡片夹的属性
     * @param {string} walletId 
     * @param {string} key 
     * @param {any} value 
     * @param {boolean} shouldForceUpdate 
     */
    setCardWalletProps(walletId, key, value, shouldForceUpdate, {
        callback,
        affectOriginVisible,
        affectUserVisible,
    } = {}) {
        key = isArray(key) ? key : [key];

        // 显隐性有关联关系  需要调整父级显隐性
        if (key[0] === 'visible') {
            // 如果不是强制修改用户级显隐性 那么显隐性以用户级为准
            if (!affectUserVisible) {
                const userVisible = this.getStore(['walletProps', 'current', walletId, 'userVisible']);
                if (isBoolean(userVisible)) {
                    callback && callback();
                    // 有用户级显隐性
                    return;
                }
            }

            this.setStore(['walletProps', 'current', walletId, ...key], value, false);

            // 用户级的显隐性优先级最高
            if (affectUserVisible) {
                this.setStore(['walletProps', 'current', walletId, 'userVisible'], value, false);
            }
            // affectOriginVisible  影响原始显隐性 用于显隐性管理
            if (affectOriginVisible) {
                this.setStore(['walletProps', 'current', walletId, 'originVisible'], value, false);
                this.setCacheMeta();
            }
            const walletLists = this.getStore('walletLists');
            const walletProps = this.getStore('walletProps');

            const idRelation = this.getStore('idRelation');
            const {
                container: containerIdRelation,
                tabs: tabsIdRelation,
                wallets: walletsIdRelation,
                cards: cardsIdRelation,
            } = idRelation;

            const $id = walletsIdRelation.moduleId[walletId];
            const parentId = walletsIdRelation.parent[$id];
            const parentModuleId = tabsIdRelation.id[parentId];

            // 找到了父级
            if (parentModuleId && tabEffect) {
                let tabVisible = false;
                const wallets = walletLists[parentId];
                // 判断 当前页签下 是不是所有的 wallet都显示了
                wallets.some(wallet => {
                    const { props = {} } = wallet;
                    const { moduleId } = props;
                    if (walletProps.current[moduleId]?.visible !== false) {
                        tabVisible = true;
                        return true;
                    }
                });
                this.setTabProps(parentModuleId, 'visible', tabVisible, false);
            }
        } else {
            this.setStore(['walletProps', 'current', walletId, ...key], value, false);
        }

        shouldForceUpdate ? this.forceUpdate(callback) : callback && callback();
    }

    /**
     * 获取某个页签下的的card
     * @param {string} tabId 
     * @param {string} walletId 
     */
    getCardsByTabIdOrWalletId(tabId, walletId) {
        let result = [];
        const tabs = this.getStore(['tabs']);
        const walletLists = this.getStore(['walletLists']);
        const cardLists = this.getStore(['cardLists']);

        // 先找wallet
        let walletList = [];
        if (tabId) {
            let tabRelationId = '';
            tabs.some(tab => {
                const { $id, props = {} } = tab || {};
                const { moduleId } = props;
                if (moduleId === tabId) {
                    tabRelationId = $id;
                    return true;
                }
            });
            if (tabRelationId) {
                walletList = walletLists[tabRelationId] || [];
            } else {
                console.log(`未找到tabId为${tabId}的页签下的walletList数据`);
            }
        }
        // 再找cardList
        if (!walletId) {
            walletList.forEach(wallet => {
                const { $id, props = {} } = wallet;
                const cardList = cardLists[$id] || [];
                result = [...result, ...cardList];
            });
        } else {
            let walletRelationId = '';
            walletList.some(wallet => {
                const { $id, props = {} } = wallet;
                const { moduleId } = props;
                if (moduleId === walletId) {
                    walletRelationId = $id;
                    return true;
                }
            });
            if (walletRelationId) {
                result = cardLists[walletRelationId] || [];
            } else {
                console.log(`未找到walletId为${walletId}的页签下的cardList数据`);
            }
        }

        return result;
    }

    /**
     * 获取卡片  TODO
     * @param {string} tabId 
     * @param {string} walletId 
     * @param {function} filter 
     * @returns {object}
     */
    getCards(tabId, walletId, filter) {
        let result = [];
        if (!tabId) {
            // 保证顺序
            const tabs = this.getStore(['tabs']);
            const walletLists = this.getStore(['walletLists']);
            const cardLists = this.getStore(['cardLists']);
            const cardProps = this.getStore(['cardProps']);
            // 扫描一遍所有的数据
            tabs.forEach(tab => {
                const { $id } = tab;
                const walletList = walletLists[$id] || [];

                // 卡片夹
                walletList.forEach(wallet => {
                    const { $id, props = {}, _isVirtually } = wallet || {};
                    const cardList = cardLists[$id] || [];

                    // 卡片
                    const temp = cardList.filter(card => {
                        const { props = {} } = card || {};
                        const { moduleId } = props;
                        const currentProps = cardProps.current[moduleId] || {};
                        return filter ? filter(currentProps) : true;
                    });
                    result = [...result, ...temp];
                });
            });
        } else {
            result = this.getCardsByTabIdOrWalletId(tabId, walletId);
            const cardProps = this.getStore(['cardProps']);

            result = result.filter(card => {
                const { props = {} } = card || {};
                const { moduleId } = props;
                const currentProps = cardProps.current[moduleId] || {};
                return filter ? filter(currentProps) : true;
            });
        }
        return result;
    }

    /**
     * TODO
     * 获取卡片属性
     * @param {string} cardId
     * @param {string} key 
     */
    getCardProps(cardId, key) {
        let value = null;
        const cardStores = this.getStore('cardStores');
        const currentCardStore = cardStores[cardId];
        if (!currentCardStore) {
            console.log(`未找到id为${cardId}的cardStore`);
            return null;
        }
        if (isUndefined(key)) {
            value = this.getStore(['cardProps', 'current', cardId]);
            value = currentCardStore.getCardProps();
            return value || {};
        }
        key = isArray(key) ? key : [key];
        value = this.getStore(['cardProps', 'current', cardId, ...key]);
        value = currentCardStore.getCardProps(key);
        return value;
    }

    /**
     * TODO
     * 卡片的属性
     * @param {string} cardId 
     * @param {string} key 
     * @param {any} value 
     * @param {boolean} shouldForceUpdate 
     * @param {function} callback 
     * @param {boolean} active 
     */
    setCardProps(cardId, key, value, shouldForceUpdate, {
        callback,
        active,
        affectOriginVisible,
    } = {}) {
        if (key === 'moduleId') {
            console.warn('moduleId为唯一属性，请勿修改');
        }
        const cardStores = this.getStore('cardStores');
        const currentCardStore = cardStores[cardId];
        if (!currentCardStore) {
            console.log(`未找到id为${cardId}的cardStore`);
            return null;
        }

        key = isArray(key) ? key : [key];
        this.setStore(['cardProps', 'current', cardId, ...key], value, false);

        // 显隐性有关联关系  需要调整父级显隐性
        if (key[0] === 'visible' || active) {
            const cardLists = this.getStore('cardLists');
            const cardProps = this.getStore('cardProps');

            const idRelation = this.getStore('idRelation');
            const {
                container: containerIdRelation,
                tabs: tabsIdRelation,
                wallets: walletsIdRelation,
                cards: cardsIdRelation,
            } = idRelation;

            const $id = cardsIdRelation.moduleId[cardId];
            const parentId = cardsIdRelation.parent[$id];
            const parentModuleId = walletsIdRelation.id[parentId];

            const userVisible = this.getStore(['walletProps', 'current', parentModuleId, 'userVisible']);

            // 找到了父级
            if (parentModuleId && key[0] === 'visible') {
                // 如果父级有用户级显隐性  则当前显隐性不生效
                if (!isBoolean(userVisible)) {
                    let tabVisible = false;
                    const wallets = cardLists[parentId];
                    // 判断 当前页签下 是不是所有的 wallet都显示了
                    wallets.some(wallet => {
                        const { props = {} } = wallet;
                        const { moduleId } = props;
                        if (cardProps.current[moduleId]?.visible !== false) {
                            tabVisible = true;
                            return true;
                        }
                    });
                    this.setCardWalletProps(parentModuleId, 'visible', tabVisible, false, { affectOriginVisible });
                } else {
                    // 还原
                    this.setStore(['cardProps', 'current', cardId, ...key], !value, false);
                }
            }

            // 设置父级为激活状态
            if (parentModuleId && active) {
                this.setCardWalletProps(parentModuleId, 'active', active, false);
            }

            if (!isBoolean(userVisible) || key[0] !== 'visible') {
                // 如果是visible属性  需要整体更新  否则可以单体更新， 也可以判断下父级显隐性是否变化再更新
                currentCardStore.setCardProps(key, value, false);
            }

            shouldForceUpdate ? this.forceUpdate(callback) : callback && callback();
        } else {
            currentCardStore.setCardProps(key, value, shouldForceUpdate, { callback });
        }
    }

    /**
     * TODO
     * 获取卡片实例
     * @param {string} cardId
     */
    getCardInstance(cardId) {
        let value = null;
        const cardStores = this.getStore('cardStores');
        const currentCardStore = cardStores[cardId];
        if (!currentCardStore) {
            console.log(`未找到id为${cardId}的cardStore`);
            return null;
        }
        value = currentCardStore.getCardInstance();
        return value;
    }

    // 是否是新模板
    isNextMeta(id) {
        id = id || this.getStore('id');
        let nextBillInfo = this.getStore('billInfo');
        const { ts } = getCacheMeta(id, nextBillInfo) || this.getStore('cacheMeta') || {};
        const currentTs = this.getStore('ts');
        return currentTs !== ts;
    }

    /**
     * 获取缓存的数据
     * @param {string} id 
     * @returns {object}
     */
    getCacheMeta(id, meta, scene) {
        id = id || this.getStore('id');
        meta = meta || this.getStore(["meta"]);

        let nextBillInfo = this.getStore('billInfo');
        const { ts, meta: cacheMeta } = getCacheMeta(id, nextBillInfo) || this.getStore('cacheMeta') || {};
        scene = scene || this.getStore('scene');
        if (!scene) {
            console.error('缺少对应的scene会导致存储出错');
            scene = SceneDefaultName;
        }

        let currentCacheMeta = (cacheMeta && cacheMeta[scene]) || [];
        // currentCacheMeta = cacheMeta || [];

        // 旧数据修正
        if (cacheMeta === undefined || isArray(cacheMeta)) {
            currentCacheMeta = meta;
        }

        const currentTs = this.getStore('ts');
        return currentTs === ts ? currentCacheMeta : meta;
    }

    /**
     * 设置缓存的数据
     * @param {string} id 
     * @param {array} meta 
     * @returns {object}
     */
    setCacheMeta(id, meta) {
        id = id || this.getStore('id');
        let scene = this.getStore('scene');

        const cacheMeta = meta || [];
        // 根据store里的数据 生成一份状态 
        if (!meta) {
            console.time('setCacheMeta');
            const container = this.getStore('container');
            if (container) {
                const containerProps = this.getStore('containerProps');
                const nextContainer = cloneObject(container);
                // nextContainer.props = { ...containerProps.origin, ...containerProps.current };
                nextContainer.props = { ...containerProps.origin };
                cacheMeta.push(nextContainer);
                // 数据
                const tabs = this.getStore('tabs');
                const walletLists = this.getStore('walletLists');
                const cardLists = this.getStore('cardLists');
                // 属性
                const tabsProps = this.getStore('tabsProps');
                const walletProps = this.getStore('walletProps');
                const cardProps = this.getStore('cardProps');
                tabs.forEach(tab => {
                    const { $id: tabId, props: tabProps, ...tabOthers } = tab;
                    const { moduleId: tabModuleId } = tabProps || {};
                    const nextTab = cloneObject(tab);
                    // const nextTabProps = { ...(tabsProps.origin[tabModuleId] || {}), ...(tabsProps.current[tabModuleId] || {}) };
                    const nextTabProps = { ...(tabsProps.origin[tabModuleId] || {}) };
                    nextTab.props = nextTabProps;
                    cacheMeta.push(nextTab);

                    // 卡片组
                    const walletList = walletLists[tabId] || [];
                    walletList.forEach(wallet => {
                        const { $id: walletId, _isVirtually } = wallet;
                        const { moduleId: walletModuleId, visible: originVisible } = wallet.props || {};
                        const nextWallet = cloneObject(wallet);
                        const { visible, originVisible: currentOriginVisible, userVisible } = walletProps.current[walletModuleId] || {};
                        // 记录一下原始的显隐性，用于解决业务场景修改显隐性情况
                        const finalOriginVisible = !isUndefined(currentOriginVisible) ? currentOriginVisible : originVisible;
                        const nextWalletProps = { ...(walletProps.origin[walletModuleId] || {}), visible, originVisible: finalOriginVisible, userVisible };
                        nextWallet.props = nextWalletProps;
                        !_isVirtually && cacheMeta.push(nextWallet);

                        // 卡片
                        const cardList = cardLists[walletId] || [];
                        cardList.forEach(card => {
                            const { $id: cardId } = card;
                            const { moduleId: cardModuleId } = card.props || {};
                            const nextCard = cloneObject(card);
                            // const { visible } = cardProps.current[cardModuleId] || {};
                            // const nextCardProps = { ...(cardProps.origin[cardModuleId] || {}), visible };
                            const nextCardProps = { ...(cardProps.origin[cardModuleId] || {}) };
                            nextCard.props = nextCardProps;
                            // 虚拟id 要不 parentId 改为tabId
                            if (_isVirtually) {
                                // 这个是特殊card  直接放在了tab下
                                nextCard.parentId = tabId;
                            }
                            cacheMeta.push(nextCard);
                        });
                    });
                });

            }
            console.timeEnd('setCacheMeta');
        }

        const currentTs = this.getStore('ts');

        let nextBillInfo = this.getStore('billInfo');
        let { meta: nextCacheMeta = {}, ts } = getCacheMeta(id, nextBillInfo) || this.getStore('cacheMeta') || {};

        if (!scene) {
            console.error('缺少对应的scene会导致存储出错');
            scene = SceneDefaultName;
        }

        // 旧数据清理
        if (isArray(nextCacheMeta)) {
            nextCacheMeta = {};
        }

        // 清理下其他场景的数据 避免场景没有更新导致问题
        if (currentTs !== ts) {
            nextCacheMeta = {};
        }

        nextCacheMeta[scene] = cacheMeta;
        // nextCacheMeta = cacheMeta;

        const billInfo = this.getStore('billInfo');

        this.setStore('cacheMeta', { meta: nextCacheMeta, ts: currentTs }, false);

        setCacheMeta(id, nextCacheMeta, currentTs, billInfo);
    }

    /**
     * 设置单据信息，缓存等功能使用的信息
     * @param {object} billInfo 
     */
    setBillInfo(billInfo = {}, shouldForceUpdate = false) {
        const prevBillInfo = this.getStore('billInfo');
        this.setStore('billInfo', { ...prevBillInfo, ...billInfo }, shouldForceUpdate);
    }

    /**
     * 设置当前场景
     * @param {string} name 
     * @param {boolean} shouldForceUpdate 
     * @param {function} callback 
     */
    setScene(name, shouldForceUpdate = true, callback) {
        name = name || SceneDefaultName;
        const { sceneMeta, sceneData } = this.getSceneData(name);

        if (!sceneMeta.length) {
            console.log('尚未初始化场景数据');
            return;
        }

        this.setStore('scene', name, false);

        const id = this.getStore('id');
        let meta = this.getStore(["meta"]);

        meta = this.getCacheMeta(id, meta, name);

        // 保留下激活页签
        const activeKey = this.getStore(['containerProps', 'current', 'activeKey']);
        // 特殊处理下 内部加载的页签
        const presetTabs = [Preset.approval.tabId, Preset.auditing.tabId];

        // 避免页签闪烁
        const presetTabsVisible = {};
        presetTabs.forEach(tabId => {
            presetTabsVisible[tabId] = this.getTabProps(tabId, 'visible');
        });

        // 清空属性 避免影响下一个场景的数据
        this.setStore(["containerProps"], {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        }, false);
        this.setStore(["tabsProps"], {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        }, false);
        this.setStore(["walletProps"], {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        }, false);
        this.setStore(["cardProps"], {
            // 原始备份
            origin: {},
            // 当前
            current: {},
        }, false);

        this.setContainerProps('activeKey', activeKey, false);

        // 避免页签闪烁
        presetTabs.forEach(tabId => {
            this.setTabProps(tabId, 'visible', presetTabsVisible[tabId], false);
        });

        this.setMeta(meta, id, false);

        if (shouldForceUpdate) {
            this.forceUpdate(() => {
                callback && callback();
            });
        } else {
            callback && callback();
        }
    }

    /**
     * 获取当前场景
     * @returns {string}
     */
    getScene() {
        const currentScene = this.getStore('scene');
        return currentScene || SceneDefaultName;
    }

    /**
     * 卡片组场景更新
     * @param {string} name 
     * @param {array} data 
     * @param {boolean} forceUpdate 
     * @param {function} callback 
     */
    setWalletPartSceneData(name, data = [], forceUpdate = true, isSort = false) {
        // 获取全量数据
        const { sceneMeta, sceneData } = this.getSceneData(SceneDefaultName);
        if (!sceneData || !data || !name) {
            console.warn('参数错误', sceneData, data, name);
            return;
        }

        // 不强制更新
        if (!forceUpdate) {
            const { sceneMeta, sceneData } = this.getSceneData(name);
            if (sceneMeta.length) {
                return;
            }
        }

        // 把智能审核和流程信息放进去
        const nextData = [];
        const preTab = {};
        data.forEach((tab, index) => {
            const { children: wallets = [], moduleId: tabModuleId } = tab;
            if (Preset.approval.tabId === tabModuleId || tabModuleId === Preset.auditing.tabId) {
                preTab[tabModuleId] = true;
            }
            nextData.push(tab);
        });

        !preTab[Preset.auditing.tabId] && nextData.push({
            moduleId: Preset.auditing.tabId,
            children: [{
                moduleId: Preset.auditing.walletId,
                // visible: true,
            }],
        });
        !preTab[Preset.approval.tabId] && nextData.push({
            moduleId: Preset.approval.tabId,
            children: [{
                moduleId: Preset.approval.walletId,
                // visible: true,
            }],
        });

        // 是否以场景为序
        if (!isSort) {
            const tabs = sceneData.children;
            const nextTabs = [];
            const walletObj = {};
            const tabIdObj = {};

            nextData.forEach((tab, index) => {
                const { children: wallets = [], moduleId: tabModuleId } = tab;
                tabIdObj[tabModuleId] = tab;
                wallets.map(wallet => {
                    const { moduleId } = wallet;
                    walletObj[moduleId] = wallet;
                    return wallet;
                });
            });

            tabs.forEach(tab => {
                const { children: wallets = [], moduleId: tabModuleId } = tab;

                if (tabIdObj[tabModuleId]) {
                    const nextWallets = [];
                    wallets.forEach(wallet => {
                        const { moduleId } = wallet;
                        if (walletObj[moduleId]) {
                            const prevWallet = walletObj[moduleId] || {};
                            // 去除用户级显隐性, 否则会继承默认场景的用户级缓存
                            const props = { ...prevWallet, userVisible: undefined, ...wallet };
                            nextWallets.push(props);
                        }
                    });

                    // 更新顺序显隐性等  使用的原始模板顺序
                    nextTabs.push({
                        moduleId: tabModuleId,
                        children: nextWallets,
                    });
                }
            });
            sceneData.children = nextTabs;
        } else {
            const walletObj = {};
            const tabs = sceneData.children;
            const nextTabs = [];

            tabs.forEach(tab => {
                const { children: wallets = [], moduleId: tabModuleId } = tab;
                wallets.forEach(wallet => {
                    const { moduleId } = wallet;
                    walletObj[moduleId] = wallet;
                });
            });
            nextData.forEach((tab, index) => {
                const { children: wallets = [], moduleId: tabModuleId } = tab;
                const nextWallets = wallets.map(wallet => {
                    const { moduleId } = wallet;
                    const prevWallet = walletObj[moduleId] || {};
                    // 去除用户级显隐性, 否则会继承默认场景的用户级缓存
                    const props = { ...prevWallet, userVisible: undefined, ...wallet };
                    return props;
                });

                // 更新顺序显隐性等，按照传入的场景数据来更新顺序
                nextTabs.push({
                    moduleId: tabModuleId,
                    children: nextWallets,
                });
            });
            sceneData.children = nextTabs;
        }

        this.setSceneData(name, sceneData);
    }

    /**
     * 处理一下sceneData顺序
     * @param {string} name 
     * @param {array} data 
     * @returns {object}
     */
    sortSceneDataByMeta(name, data = {}) {
        const { sceneMeta, sceneData } = this.getSceneData(SceneDefaultName);

        const { children: tabs = [], moduleId } = data;
        const { children: defaultTabs = [], moduleId: defaultModuleId } = sceneData;

        if (!sceneData || !data || !name ||
            !moduleId || !tabs.length ||
            !defaultModuleId || !defaultTabs.length ||
            moduleId !== defaultModuleId
        ) {
            console.warn('参数错误', sceneData, data, name);
            return data;
        }

        const tabObj = {};
        tabs.forEach((tab = {}) => {
            const { children: wallets = [], moduleId: tabModuleId, ...others } = tab;

            const walletObj = {};
            wallets.forEach((wallet = {}) => {
                const { children: cards = [], moduleId: walletModuleId, ...others } = wallet;

                const cardObj = {};
                cards.forEach((card = {}) => {
                    const { children, moduleId: cardModuleId, ...others } = card;
                    cardObj[cardModuleId] = { ...card };
                });

                walletObj[walletModuleId] = {
                    ...wallet,
                    children: cardObj,
                };
            });

            tabObj[tabModuleId] = {
                ...tab,
                children: walletObj,
            };
        });
        // 默认数据顺序
        const dataObj = { ...data, children: tabObj };

        const nextData = { ...data, children: [] };
        // 按照默认meta重新排序
        defaultTabs.forEach((tab = {}) => {
            const { children: wallets = [], moduleId: tabModuleId, ...others } = tab;

            if (tabObj[tabModuleId]) {
                const walletObj = tabObj[tabModuleId]?.children || {};
                const nextWallets = [];
                wallets.forEach((wallet = {}) => {
                    const { children: cards = [], moduleId: walletModuleId, ...others } = wallet;

                    if (walletObj[walletModuleId]) {
                        const cardObj = walletObj[walletModuleId]?.children || {};
                        const nextCards = [];
                        cards.forEach((card = {}) => {
                            const { children, moduleId: cardModuleId, ...others } = card;
                            if (cardObj[cardModuleId]) {
                                nextCards.push({ ...cardObj[cardModuleId] });
                            }
                        });

                        nextWallets.push({
                            ...walletObj[walletModuleId],
                            children: nextCards,
                        });
                    }
                });

                nextData.children.push({
                    ...tabObj[tabModuleId],
                    children: nextWallets,
                });
            }
        });

        return nextData;
    }

    /**
     * 处理一下sceneData取出剩余的数据，默认只处理卡片组
     * @param {string} name 
     * @param {array} data 
     * @returns {object}
     */
    remainSceneDataByMeta(name, data = {}) {
        const { sceneMeta, sceneData } = this.getSceneData(SceneDefaultName);

        const { children: tabs = [], moduleId } = data;
        const { children: defaultTabs = [], moduleId: defaultModuleId } = sceneData;

        if (!sceneData || !data || !name ||
            !moduleId || !tabs.length ||
            !defaultModuleId || !defaultTabs.length ||
            moduleId !== defaultModuleId
        ) {
            console.warn('参数错误', sceneData, data, name);
            return data;
        }

        const tabObj = {};
        tabs.forEach((tab = {}) => {
            const { children: wallets = [], moduleId: tabModuleId, ...others } = tab;

            const walletObj = {};
            wallets.forEach((wallet = {}) => {
                const { children: cards = [], moduleId: walletModuleId, ...others } = wallet;

                const cardObj = {};
                cards.forEach((card = {}) => {
                    const { children, moduleId: cardModuleId, ...others } = card;
                    cardObj[cardModuleId] = { ...card };
                });

                walletObj[walletModuleId] = {
                    ...wallet,
                    children: cardObj,
                };
            });

            tabObj[tabModuleId] = {
                ...tab,
                children: walletObj,
            };
        });

        const nextData = { ...data, children: [] };
        // 按照默认meta重新排序
        defaultTabs.forEach((tab = {}) => {
            const { children: wallets = [], moduleId: tabModuleId, useRemain, ...others } = tab;
            // tab 是否走其余数据逻辑
            if (useRemain) {
                if (!tabObj[tabModuleId]) {
                    // 如果没有卡片组件 则排除整个
                    const nextWallets = [];
                    wallets.forEach((wallet = {}) => {
                        const { children: cards = [], moduleId: walletModuleId, ...others } = wallet;

                        const nextCards = [];
                        cards.forEach((card = {}) => {
                            const { children, moduleId: cardModuleId, ...others } = card;
                            nextCards.push({ ...card });
                        });

                        nextWallets.push({
                            ...wallet,
                            children: nextCards,
                        });
                    });
                    nextData.children.push({
                        ...tab,
                        children: nextWallets,
                    });
                }
            } else {
                if (tabObj[tabModuleId]) {
                    const walletObj = tabObj[tabModuleId]?.children || {};
                    // 如果没有卡片组件 则排除整个
                    const nextWallets = [];
                    wallets.forEach((wallet = {}) => {
                        const { children: cards = [], moduleId: walletModuleId, useRemain = true, ...others } = wallet;
                        // wallet 是否走其余数据逻辑，默认处理这一层的逻辑
                        if (useRemain) {
                            if (!walletObj[walletModuleId]) {
                                const nextCards = [];
                                cards.forEach((card = {}) => {
                                    const { children, moduleId: cardModuleId, ...others } = card;
                                    nextCards.push({ ...card });
                                });
                                nextWallets.push({
                                    ...wallet,
                                    children: nextCards,
                                });
                            }
                        } else {
                            if (walletObj[walletModuleId]) {
                                const cardObj = walletObj[walletModuleId]?.children || {};
                                const nextCards = [];
                                cards.forEach((card = {}) => {
                                    const { children, moduleId: cardModuleId, useRemain, ...others } = card;
                                    // wallet 是否走其余数据逻辑
                                    if (useRemain) {
                                        if (!cardObj[cardModuleId]) {
                                            nextCards.push({ ...card });
                                        }
                                    } else {
                                        if (cardObj[cardModuleId]) {
                                            nextCards.push({ ...cardObj[cardModuleId] });
                                        }
                                    }
                                });

                                nextWallets.push({
                                    ...walletObj[walletModuleId],
                                    children: nextCards,
                                });
                            }
                        }
                    });
                    nextData.children.push({
                        ...tabObj[tabModuleId],
                        children: nextWallets,
                    });
                } else {
                    // 如果没有卡片组件 则排除整个
                    const nextWallets = [];
                    wallets.forEach((wallet = {}) => {
                        const { children: cards = [], moduleId: walletModuleId, ...others } = wallet;

                        const nextCards = [];
                        cards.forEach((card = {}) => {
                            const { children, moduleId: cardModuleId, ...others } = card;
                            nextCards.push({ ...card });
                        });

                        nextWallets.push({
                            ...wallet,
                            children: nextCards,
                        });
                    });
                    nextData.children.push({
                        ...tab,
                        children: nextWallets,
                    });
                }
            }
        });

        return nextData;
    }

    /**
     * 设置场景数据
     * @param {string} name 
     * @param {array} data 
     */
    setSceneData(name, data) {

        if (!name || !data || !isObject(data)) {
            console.log('setSceneData 数据异常');
            return;
        }

        const container = this.getStore('container');

        if (!container) {
            console.log('模板缓存没有初始化');
            return;
        }

        const id = this.getStore('id');
        const meta = this.getStore(["meta"]);

        const defaultMeta = this.getCacheMeta(id, meta, SceneDefaultName);
        if (!isArray(defaultMeta)) {
            console.log('defaultMeta 数据格式有误');
            return;
        }
        // 按id整理下初始数据
        const defaultMetaObj = defaultMeta.reduce((accumulator, element) => {
            const { $id, props, ...others } = element;
            const { moduleId } = props;
            accumulator.id[$id] = element;
            accumulator.moduleId[moduleId] = element;
            return accumulator;
        }, { id: {}, moduleId: {} });

        // 从初始数据里去除场景数据
        const nextMeta = [];
        // 第一层是container
        const { children: containerChildren, ...containerOthers } = data;
        const containerProps = this.getStore('containerProps');
        const nextContainer = cloneObject(container);
        // nextContainer.props = { ...containerProps.origin, ...containerProps.current };
        nextContainer.props = { ...containerProps.origin, ...containerOthers };
        nextMeta.push(nextContainer);
        if (containerChildren && isArray(containerChildren) && containerChildren.length) {
            // 第二层是tabs
            // 属性
            const tabsProps = this.getStore('tabsProps');
            const walletsProps = this.getStore('walletProps');
            const cardProps = this.getStore('cardProps');
            containerChildren.forEach(tab => {
                const { children: tabChildren, moduleId: tabModuleId, ...tabOthers } = tab;

                const nextTab = cloneObject(defaultMetaObj.moduleId[tabModuleId] || {});
                // const nextTabProps = { ...(tabsProps.origin[tabModuleId] || {}), ...(tabsProps.current[tabModuleId] || {}) };
                const nextTabProps = { ...(tabsProps.origin[tabModuleId] || {}), ...tabOthers };
                nextTab.props = nextTabProps;
                nextMeta.push(nextTab);

                if (tabChildren && isArray(tabChildren) && tabChildren.length) {
                    // 第三层是wallets
                    // 卡片组
                    tabChildren.forEach(wallet => {
                        const { children: walletChildren, moduleId: walletModuleId, ...walletOthers } = wallet;
                        const nextWallet = cloneObject(defaultMetaObj.moduleId[walletModuleId] || {});

                        const { $id: walletId, path } = nextWallet;

                        // 虚拟id 实际是card
                        if (path && path !== cardWalletPath) {
                            // const { visible } = cardProps.current[cardModuleId] || {};
                            // const nextCardProps = { ...(cardProps.origin[cardModuleId] || {}), visible };
                            const nextCardProps = { ...(cardProps.origin[walletModuleId] || {}), ...walletOthers };
                            nextWallet.props = nextCardProps;
                        } else {
                            const originVisible = nextWallet?.props?.visible;

                            const { visible, originVisible: currentOriginVisible, userVisible } = walletsProps.current[walletModuleId] || {};
                            // 记录一下原始的显隐性，用于解决业务场景修改显隐性情况
                            const finalOriginVisible = !isUndefined(currentOriginVisible) ? currentOriginVisible : originVisible;

                            // 如果场景有初始显隐性，优先级要低于用户级
                            const nextWalletProps = {
                                ...(walletsProps.origin[walletModuleId] || {}),
                                visible,
                                originVisible: finalOriginVisible,
                                // 不继承用户级显隐性
                                // userVisible,
                                userVisible: undefined,
                                ...walletOthers,
                            };
                            nextWallet.props = nextWalletProps;
                        }

                        nextMeta.push(nextWallet);

                        // 第四层是cards
                        if (walletChildren && isArray(walletChildren) && walletChildren.length) {

                            // 卡片
                            walletChildren.forEach(card => {
                                const { moduleId: cardModuleId, ...cardOthers } = card;
                                const nextCard = cloneObject(defaultMetaObj.moduleId[cardModuleId] || {});

                                // const { visible } = cardProps.current[cardModuleId] || {};
                                // const nextCardProps = { ...(cardProps.origin[cardModuleId] || {}), visible };
                                const nextCardProps = { ...(cardProps.origin[cardModuleId] || {}), ...cardOthers };
                                nextCard.props = nextCardProps;

                                nextMeta.push(nextCard);
                            });
                        }
                    });
                }
            });
        }

        const currentTs = this.getStore('ts');
        let nextBillInfo = this.getStore('billInfo');
        let { ts, meta: nextCacheMeta = {} } = getCacheMeta(id, nextBillInfo) || this.getStore('cacheMeta') || {};

        // 旧数据清理
        if (isArray(nextCacheMeta)) {
            nextCacheMeta = {};
        }

        // 清理下其他场景的数据 避免场景没有更新导致问题
        if (currentTs !== ts) {
            nextCacheMeta = {};
        }

        nextCacheMeta[name] = nextMeta;
        // nextCacheMeta = cacheMeta;

        const billInfo = this.getStore('billInfo');

        this.setStore('cacheMeta', { meta: nextCacheMeta, ts: currentTs }, false);

        setCacheMeta(id, nextCacheMeta, currentTs, billInfo);
    }

    /**
     * 获取场景数据
     * @param {string} name 
     * @returns {array}
     */
    getSceneData(name) {
        const currentScene = this.getStore('scene');

        name = name || currentScene || SceneDefaultName;

        const id = this.getStore('id');
        let meta = this.getCacheMeta(id, [], name);

        // 可能会有问题  暂时用一下
        const sceneData = {};
        // 用于记录关系
        const relation = {};

        meta.forEach(element => {
            const { $id, path, props = {}, parentId: currentParentId } = element;
            const { moduleId, visible, originVisible, userVisible } = props || {};

            const hasParentId = relation[currentParentId];

            if (moduleId === id && path === containerPath) {
                // 容器区域
                sceneData[moduleId] = sceneData[moduleId] || {
                    children: [],
                    moduleId,
                };

                // 指向
                relation[$id] = sceneData[moduleId].children;
            } else if (hasParentId && path === panePath) {
                // 页签项
                const parentNode = relation[currentParentId];

                const currentNode = {
                    children: [],
                    moduleId,
                };

                parentNode.push(currentNode);

                // 指向
                relation[$id] = currentNode.children;
            } else if (hasParentId && path === cardWalletPath) {
                // 如果卡片夹
                const parentNode = relation[currentParentId];

                const currentNode = {
                    children: [],
                    moduleId,
                    visible,
                    originVisible,
                    userVisible,
                };

                parentNode.push(currentNode);

                // 指向
                relation[$id] = currentNode.children;
            } else if (hasParentId) {
                // 卡片数据
                const parentNode = relation[currentParentId];

                const currentNode = {
                    children: [],
                    moduleId,
                    visible,
                };

                parentNode.push(currentNode);

                // 指向
                relation[$id] = currentNode.children;
            }
        });

        const nextSceneData = { ...(sceneData[id] || {}) };

        return {
            sceneData: nextSceneData,
            sceneMeta: meta,
        };
    }

    /**
     * 创建模板数据, 一般用于自定义页签
     * @param {object} config 
     * @param {string} type 
     */
    createItem(config = {}, type = "tab") {
        const parentId = this.getStore('id');
        let item = {};
        switch (type) {
            case 'tab':
                const { moduleId, tab } = config;
                item = {
                    $id: moduleId,
                    parentId: parentId,
                    __isCustom: true,
                    props: {
                        visible: true,
                        moduleId,
                        tab: tab || 'default_title',
                        ...config,
                    },
                };
                break;
            default:
                break;
        }

        return item;
    }

    // 设置监听事件
    addEventListener = (eventName, callback) => {
        let eventListenerObj = this.getStore(['listenerStore']) || {};
        let eventCallback = eventListenerObj[eventName] || [];
        eventCallback.push(callback);
        this.setStore(['listenerStore'], { ...eventListenerObj, [eventName]: eventCallback });
    }

    // 获取监听事件
    getEventListener = name => {
        let eventListenerObj = this.getStore(['listenerStore']) || {};
        if (!name) {
            return eventListenerObj;
        }
        return eventListenerObj[name] || [];
    }

    removeEventListener = (eventName, callback) => {
        let eventListenerObj = this.getStore(['listenerStore']);
        let eventCallback = eventListenerObj[eventName] || [];
        const index = eventCallback.findIndex(item => item === callback);
        index !== -1 && eventCallback.splice(index, 1);
    }

    triggerEventListener = eventName => {
        const events = this.getEventListener(eventName);
        events && events.forEach(item => isFunction(item) && item());
    }

    /**
     * 钩子
     */
    getHooks = () => {
        // 这样处理的一下 才能报错  方法内部的this 永远指向 实例  否则会指向下面的 {} 对象
        this.getMeta = this.getMeta.bind(this);
        this.setMeta = this.setMeta.bind(this);

        return {
            // 这个是给公共层提供 组件在使用baseComponent 是可以正常运行
            setRef: this.setRef,
            getRef: this.getRef,
            removeRef: this.removeRef,

            // 按路径索引 给内部使用
            getStore: this.getStore.bind(this),
            setStore: this.setStore.bind(this),

            // 
            isSmartContainer: this.isSmartContainer.bind(this),
            reloadPretreatmentCard: this.reloadPretreatmentCard.bind(this),

            /*-------------------上面的部分------------------*/

            //模板
            getMeta: this.getMeta.bind(this),
            getViewMeta: this.getViewMeta.bind(this),
            setMeta: this.setMeta.bind(this),
            setMetaLang: this.setMetaLang.bind(this),
            getMetaLang: this.getMetaLang.bind(this),
            createItem: this.createItem.bind(this),

            // 区域
            getContainerProps: this.getContainerProps.bind(this),
            setContainerProps: this.setContainerProps.bind(this),
            getContainerActiveTab: this.getContainerActiveTab.bind(this),
            setContainerActiveTab: this.setContainerActiveTab.bind(this),

            // 页签
            getTabs: this.getTabs.bind(this),
            getTabProps: this.getTabProps.bind(this),
            setTabProps: this.setTabProps.bind(this),

            // 卡片夹
            getCardWallets: this.getCardWallets.bind(this),
            getCardWalletProps: this.getCardWalletProps.bind(this),
            setCardWalletProps: this.setCardWalletProps.bind(this),

            // 卡片
            getCards: this.getCards.bind(this),
            getCardProps: this.getCardProps.bind(this),
            setCardProps: this.setCardProps.bind(this),
            getCardInstance: this.getCardInstance.bind(this),

            // 缓存
            getCacheMeta: this.getCacheMeta.bind(this),
            setCacheMeta: this.setCacheMeta.bind(this),
            setBillInfo: this.setBillInfo.bind(this),

            // 事件
            addEventListener: this.addEventListener.bind(this),
            getEventListener: this.getEventListener.bind(this),
            removeEventListener: this.removeEventListener.bind(this),
            triggerEventListener: this.triggerEventListener.bind(this),

            // 场景
            setScene: this.setScene.bind(this),
            getScene: this.getScene.bind(this),
            setSceneData: this.setSceneData.bind(this),
            sortSceneDataByMeta: this.sortSceneDataByMeta.bind(this),
            remainSceneDataByMeta: this.remainSceneDataByMeta.bind(this),
            getSceneData: this.getSceneData.bind(this),
            setWalletPartSceneData: this.setWalletPartSceneData.bind(this),
        };
    };
}

export default hookFactory(Store);
